var exports = {
  "G": "stateReasonLink__aKImJF",
  "T": "closerLink__PVdd2T",
};

module.exports = exports;
